'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series, store, layout, isStacked, extraOptions) {
    switch (layout.type) {
        case _.CHART_TYPE_PIE:
            series = (0, _pie2.default)(series, store, layout, isStacked, extraOptions.colors);
            break;
        case _.CHART_TYPE_GAUGE:
            series = (0, _gauge2.default)(series, extraOptions.dashboard);
            break;
        default:
            series = getDefault(series, store, layout, isStacked, extraOptions.colors);
    }

    series.forEach(function (seriesObj) {

        // animation
        seriesObj.animation = {
            duration: DEFAULT_ANIMATION_DURATION
        };
    });

    return series;
};

var _getCumulativeData = require('./../getCumulativeData');

var _getCumulativeData2 = _interopRequireDefault(_getCumulativeData);

var _pie = require('./pie');

var _pie2 = _interopRequireDefault(_pie);

var _gauge = require('./gauge');

var _gauge2 = _interopRequireDefault(_gauge);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_ANIMATION_DURATION = 300;

function getColor(colors, index) {
    return colors[index] || getColor(colors, index - colors.length);
}

function getDefault(series, store, layout, isStacked, colors) {
    series.forEach(function (seriesObj, index) {
        // show values
        if (layout.showValues) {
            seriesObj.dataLabels = {
                enabled: true
            };
        }

        // stacked
        if (isStacked) {
            // DHIS2-1060: stacked charts can optionally be shown as 100% stacked charts
            seriesObj.stacking = layout.percentStackedValues === true ? 'percent' : 'normal';
        }

        // DHIS2-2101
        // show bar/columm chart as EPI curve (basically remove spacing between bars/columns)
        var chartType = (0, _type2.default)(layout.type).type;

        if ((chartType === 'column' || chartType === 'bar') && layout.noSpaceBetweenColumns) {
            seriesObj.pointPadding = 0;
            seriesObj.groupPadding = 0;
        }

        // color
        seriesObj.color = getColor(colors, index);
    });

    // DHIS2-701: use cumulative values
    if (layout.cumulativeValues === true) {
        series = (0, _getCumulativeData2.default)(series);
    }

    return series;
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/series/index.js
 ** module id = 246
 ** module chunks = 0 1
 **/